import React from 'react'
import Navbar from '../HomePage/Navbar'
import Footer from '../HomePage/Footer'
import PaymentPage from './PaymentPage'
function PaymentIndex() {
  return (
    <div>
      <Navbar />
      <PaymentPage />
      <Footer/>
    </div>
  )
}

export default PaymentIndex;
